import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { ColorPalette } from 'shared/consts/colorPalette';
import { ListItems } from 'shared/ui/ListItems';

export const InboundEmail: FC = () => {
	const { t } = useTranslation();
	return (
		<>
			<Typography variant={'h5'} color={ColorPalette.astronaut}>
				{t('extensions.ex_list.inbound_email.title')}
			</Typography>
			<Typography variant={'body2'} color={ColorPalette.baliHai}>
				{t('extensions.ex_list.inbound_email.drawer_description')}
			</Typography>
			<Typography variant={'body1'} color={ColorPalette.astronaut}>
				{t('extensions.ex_list.overview')}
			</Typography>
			<Typography variant={'body2'} color={ColorPalette.baliHai}>
				{t('extensions.ex_list.inbound_email.overview_description')}
			</Typography>
			<Typography variant={'body1'} color={ColorPalette.astronaut}>
				{t('extensions.ex_list.use_cases')}
			</Typography>
			<Typography variant={'body1'} color={ColorPalette.baliHai}>
				{t('extensions.ex_list.inbound_email.use_cases_description_1')}
			</Typography>
			<Typography variant={'body1'} color={ColorPalette.baliHai}>
				{t('extensions.ex_list.inbound_email.use_cases_description_2')}
			</Typography>
			<ListItems
				list={[
					{ label: 'extensions.ex_list.inbound_email.use_cases_li_1' },
					{ label: 'extensions.ex_list.inbound_email.use_cases_li_2' },
				]}
			/>
			<Typography variant={'body1'} color={ColorPalette.baliHai}>
				{t('extensions.ex_list.inbound_email.use_cases_description_3')}
			</Typography>
		</>
	);
};
